module.exports = __webpack_public_path__ + "static/img/platBg.2bb892d5.png";